import React, { useContext } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { ICategoryContext, CategoryContext } from '../../categoryState/categoryContext';
import { List } from './List/List';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import style from './Categories.module.scss';

export const Categories: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { changeCurrentPage, categories, currentPage, countOfItems } = useContext<ICategoryContext>(CategoryContext);

	return (
		<>
			{categories.totalCount ? (
				<div className={style.container} data-test="Categories">
					<List />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={categories.totalCount}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			) : (
				<NoResultsFound isVisible={!isLoading} />
			)}
		</>
	);
};
